<template>
  <div class="error404">
    Seite nicht gefunden
  </div>
</template>

<script>
export default {
  name: "Error404"
};
</script>

<style scoped lang="scss">
.login {
  height: 75vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
